import React from "react";
import FormLabel from "./styled/FormLabel";
import CustomDatePicker from "./styled/CustomDatePicker";
import InputField from "./styled/InputField";
import { faAddressCard } from "@fortawesome/free-solid-svg-icons";

const BirthdateForm = ({
  birthdate,
  handleBirthdateChange,
  showCedulaInput,
  cedula,
  setCedula,
}) => {
  const handleDatePickerFocus = () => {};

  const handleDatePickerBlur = () => {};

  return (
    <>
      <FormLabel>Fecha de nacimiento</FormLabel>
      <CustomDatePicker
        selected={birthdate}
        onChange={handleBirthdateChange}
        onFocus={handleDatePickerFocus}
        onBlur={handleDatePickerBlur}
        placeholderText="Fecha de nacimiento"
      />

      {showCedulaInput && (
        <>
          <FormLabel>Cédula</FormLabel>
          <InputField
            icon={faAddressCard}
            type="text"
            placeholder="Ingresar cédula"
            cedulaMask="999-9999999-9"
            value={cedula}
            onChange={(e) => setCedula(e.target.value)}
          />
        </>
      )}
    </>
  );
};

export default BirthdateForm;
